import { render, staticRenderFns } from "./MarkdownRender.vue?vue&type=template&id=055f62ba"
import script from "./MarkdownRender.vue?vue&type=script&lang=js"
export * from "./MarkdownRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports